import React, { useState, forwardRef, useEffect, useRef } from 'react';

import { ReactSortable } from "react-sortablejs";

import { Puck, Drawer } from "@measured/puck";
import debounce from 'lodash.debounce';
import "@measured/puck/puck.css";
import { Link, json, useParams, useNavigate } from 'react-router-dom';
import config from './config';
import DrawerROI from './DrawerROI';
import Svg from '../../../../component/Svg';
import landingImage1 from '../images/landing-page-1.png';
import landingImage2 from '../images/landing-page-2.png';

import Input from "../../../../core/Inputs/DefaultInput";
import Card from "../../../../core/Card";
import style from "../../../../views/style.module.css";

// import Select from "react-select/creatable";
import { performHttpRequest } from '../../../../../axios/PerformHttpRequest';
import { toast } from 'react-toastify';
import { groupBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import EditConditionalComponent from './EditConditionalComponent';
const apiUrl = process.env.REACT_APP_NODE_API_URL;


// Save the data to your database

const CustomComponent = forwardRef < HTMLDivElement > ((props, ref) => {
    // console.log("props=====>", props.children, ref)
    return <div ref={ref}>{props.children}</div>;
});


export default function PuckEditor() {

    const modalRef = useRef(null);
    const { id } = useParams();
    const navigate = useNavigate();

    const [editorData, setEditData] = useState(null);


    const [roiTemplateDetail, setRoiTemplateDetail] = useState(null)
    const [landingPage, setLandingPage] = useState("");
    const [roiTemplateTypeId, setRoiTemplateTypeId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [pages, setPages] = useState([]);
    const [selectedRoiPageId, setSelectedRoiPageId] = useState({
        roi_page_id: null,
        page_name: null
    });
    const [renameRoiPageId, setRenameRoiPageId] = useState(null);
    const [newPageName, setNewPageName] = useState("");
    const [duplicateTemplate, setDuplicateTemplate] = useState({ roi_page_id: null, page_name: null, structure: null });
    const [roiPageId, setRoiPageId] = useState("")
    const [roiName, setRoiName] = useState("");
    const [currentReportId, setCurrentReportId] = useState()

    const [configObject, setConfigObject] = useState(config)
    //Add condtion compoent
    const [allElementArray, setAllElementArray] = useState([]);

    const [reportPages, setReportPages] = useState([]);

    // "left" and "right" are visible by default, "pages" is hidden
    const [visibleBars, setVisibleBars] = useState({ left: true, right: true, pages: false });

    useEffect(() => {
        getPagesList()
        getRoiDetail();
        //getPagesListName()
    }, [id])

    // for duplicate field update handle change

    useEffect(() => {
        const fetchPagesList = async () => {
          try {
            const url = window.location.href;
            const parts = url.split('/');
            const id = parts[parts.length - 1];
    
            const response = await performHttpRequest(
              "GET",
              `${apiUrl}/roi-pages/detail/${id}`,
              ""
            );
            const pagesData = response?.data?.result?.map(page => ({
              value: page.roi_page_id,
              label: page.page_name
            })) || [];
    
            // Update the config object directly
            setConfigObject(prevConfig => ({
              ...prevConfig,
              components: {
                ...prevConfig.components,
                BannerLeftTextRightImage: {
                  ...prevConfig.components.BannerLeftTextRightImage,
                  fields: {
                    ...prevConfig.components.BannerLeftTextRightImage.fields,
                    Button: {
                      ...prevConfig.components.BannerLeftTextRightImage.fields.Button,
                      objectFields: {
                        ...prevConfig.components.BannerLeftTextRightImage.fields.Button.objectFields,
                        PageList: {
                          ...prevConfig.components.BannerLeftTextRightImage.fields.Button.objectFields.PageList,
                          options: pagesData,
                        },
                      },
                    },
                  },
                },
                CardLayout1:{
                    ...prevConfig.components.CardLayout1,
                    fields: {
                        ...prevConfig.components.CardLayout1.fields,
                        Card1: {
                            ...prevConfig.components.CardLayout1.fields.Card1,
                            objectFields: {
                                ...prevConfig.components.CardLayout1.fields.Card1.objectFields,
                                PageList: {
                                    ...prevConfig.components.CardLayout1.fields.Card1.objectFields.PageList,
                                    options: pagesData,
                                }
                            }

                        },
                        Card2: {
                            ...prevConfig.components.CardLayout1.fields.Card2,
                            objectFields: {
                                ...prevConfig.components.CardLayout1.fields.Card2.objectFields,
                                PageList: {
                                    ...prevConfig.components.CardLayout1.fields.Card2.objectFields.PageList,
                                    options: pagesData,
                                }
                            }

                        },
                        Card3: {
                            ...prevConfig.components.CardLayout1.fields.Card3,
                            objectFields: {
                                ...prevConfig.components.CardLayout1.fields.Card3.objectFields,
                                PageList: {
                                    ...prevConfig.components.CardLayout1.fields.Card3.objectFields.PageList,
                                    options: pagesData,
                                }
                            }

                        },
                        Card4: {
                            ...prevConfig.components.CardLayout1.fields.Card4,
                            objectFields: {
                                ...prevConfig.components.CardLayout1.fields.Card4.objectFields,
                                PageList: {
                                    ...prevConfig.components.CardLayout1.fields.Card4.objectFields.PageList,
                                    options: pagesData,
                                }
                            }

                        }
                    }
                },
                Button:{
                    ...prevConfig.components.Button,
                    fields: {
                        ...prevConfig.components.Button.fields,
                        PageList: {
                            ...prevConfig.components.Button.fields.PageList,
                            options: pagesData,
                          },
                    },
                },

              },
            }));
          } catch (error) {
            console.error("Failed to fetch pages list", error);
          }
        };
    
        fetchPagesList();
      }, []);
    const getRoiDetail = async () => {
        const response = await performHttpRequest(
            "GET",
            `${apiUrl}/roi/getRoiDetail/${id}`,
            ""
        );
        setRoiName(response?.data?.result?.roi_name)      
    }

    const getPagesList = async () => {
        const response = await performHttpRequest(
            "GET",
            `${apiUrl}/roi-pages/detail/${id}`,
            ""
        );
        setPages(response?.data?.result)

        if (response?.data?.result?.length > 0) {
            const structure = response?.data?.result[1]?.structure;
            // if (editorData == null) {
            // console.log("structure=====>", structure);

            if (structure) {
                try {
                    const parsedStructure = JSON.parse(structure);
                    setEditData(parsedStructure);
                } catch (error) {
                    console.error("Failed to parse JSON structure:", error);
                }
            } else {
                console.error("Structure is empty or null.");
            }
            
            setEditData(JSON?.parse(structure));
            setCurrentReportId(response?.data?.result[0]?.roi_page_id)
        }

        const resultarray = response?.data?.result;
        const reportPages = resultarray.filter(item=>item.roi_template_type_id ===6);
        setReportPages(reportPages)

    }

    const replaceUUIDs = (obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map(item => replaceUUIDs(item));
        }

        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => {
                if (key === 'uuid' && (value === '' || value === null || value === undefined)) {
                    return [key, uuidv4()];
                }
                return [key, replaceUUIDs(value)];
            })
        );
    };

    const handleEditChange = (newData) => {
        newData = replaceUUIDs(newData);
        console.log("newData", JSON.stringify(newData))
        setEditData(newData);

    };

    const onPublish = async () => {
        try {
            const firstRoiPageId = pages?.[0]?.roi_page_id;
            const response = await performHttpRequest(
                "PATCH",
                `${apiUrl}/roi-pages/update/${roiPageId ? roiPageId : firstRoiPageId}`,
                {
                    structure: editorData,
                }
            );
            if (response.data?.statusCode === 200) {
                toast.success(response?.data?.msg)
                getPagesList()
            }

        } catch (error) {
            toast.error(error?.response?.data?.responseText);
        }
    };

    const toggleBar = (bar) => {
        setVisibleBars(prevBars => {
            // Special case for the "pages" bar
            if (bar === 'pages') {
                return { left: prevBars.left, right: false, pages: !prevBars.pages };
            } else if (bar === 'right' && prevBars.pages) {
                // If "pages" is visible and "right" is toggled, hide "pages"
                return { ...prevBars, right: !prevBars.right, pages: false };
            } else {
                // Toggle normally for "left" or "right" when "pages" is not involved
                return { ...prevBars, [bar]: !prevBars[bar] };
            }
        });
    };
    /***Pages List***/

    const handleLandingPageChange = (e, item) => {
        const selectedValue = e.target.value;
        const isChecked = e.target.checked;
        let newRoiTemplateId;

        switch (selectedValue) {
            case "Landing Page":
                newRoiTemplateId = 1;
                break;
            case "User Profiling":
                newRoiTemplateId = 2;
                break;
            case "User Input Form":
                newRoiTemplateId = 3;
                break;
            case "Savings Summary":
                newRoiTemplateId = 4;
                break;
            case "Value-add Details":
                newRoiTemplateId = 5;
                break;
            case "Savings Report":
                newRoiTemplateId = 6;
                break;
            default:
                newRoiTemplateId = null;
                break;
        }

        if (isChecked) {
            // If checkbox is checked, set the value
            setLandingPage(selectedValue);
            setRoiTemplateTypeId(newRoiTemplateId); // Update roiTemplateTypeId
            setSelectedItem(item); // Store the selected item
        } else {
            // If checkbox is unchecked, ensure landingPage is set to null (no selection)
            setLandingPage(""); // or set to any default value as needed
            setRoiTemplateTypeId(null); // Reset roiTemplateTypeId
            setSelectedItem(null); // Reset the selected item
        }
    };

    const getTemplateDetails = async () => {
        try {
            const response = await performHttpRequest(
                "GET",
                `${apiUrl}/roi/roiTemplate`,
                ""
            );
            setRoiTemplateDetail(response?.data?.template);
        } catch (error) {
            console.error("Error", error);
            toast.error(error?.response?.data?.responseText);
        }
    };


    const handleTemplateAdd = async () => {
        try {
            const response = await performHttpRequest(
                "POST",
                `${apiUrl}/roi-pages/add`,
                {
                    roi_template_page_id: "",
                    roi_template_type_id: roiTemplateTypeId,
                    roi_id: id,
                    page_name: landingPage,
                    roi_template_id: "",
                    structure: selectedItem?.structure,
                    roi_template_page_img: selectedItem?.roi_template_page_img?.replace(".", "")
                }
            );
            if (response.data?.statusCode === 200) {
                setRoiTemplateDetail(response?.data?.template);
                toast.success(response?.data?.msg)
                getPagesList()
            }
        } catch (error) {
            console.error("Error", error);
            toast.error(error?.response?.data?.responseText);
        }
    };

    const handleDuplicateTemplate = (roi_page_id, page_name, structure) => {
        setDuplicateTemplate({
            roi_page_id: roi_page_id,
            page_name: page_name,
            structure: structure
        });
    }

    const confirmDuplicate = async () => {

        try {
            if (duplicateTemplate.roi_page_id) {
                const response = await performHttpRequest(
                    "POST",
                    `${apiUrl}/roi-pages/add`,
                    {
                        roi_page_id: duplicateTemplate.roi_page_id,
                        roi_template_page_id: "",
                        roi_template_type_id: roiTemplateTypeId,
                        roi_id: id,
                        page_name: duplicateTemplate.page_name,
                        roi_template_id: "",
                        structure: duplicateTemplate.structure,
                        is_active: "",
                        added_by: "",
                        add_date_time: "",
                        last_modified: "",
                        roi_template_page_img: ""
                    }
                );
                if (response.data?.statusCode === 200) {
                    toast.success(response?.data?.msg)
                    getPagesList()
                }
            }

        } catch (error) {
            console.error("Error", error);
            toast.error(error?.response?.data?.responseText);
        }
    }

    const handleDeleteTemplate = (roi_page_id, page_name) => {
        // console.log("page", page_name)
        setSelectedRoiPageId({
            roi_page_id: roi_page_id,
            page_name: page_name
        });
    }

    const confirmDeleteButton = async () => {
        try {
            if (selectedRoiPageId.roi_page_id) {
                const response = await performHttpRequest(
                    "DELETE",
                    `${apiUrl}/roi-pages/delete/${selectedRoiPageId.roi_page_id}`,
                    ""
                );
                // console.log("trd", response);
                if (response.data?.statusCode === 200) {
                    toast.success(response?.data?.msg)
                    getPagesList()
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.responseText);
        }

    }

    const handleRenameTemplate = (roi_page_id, page_name) => {
        setRenameRoiPageId(roi_page_id);
        setNewPageName(page_name);
    }

    const confirmRename = async () => {
        try {
            if (renameRoiPageId) {
                const response = await performHttpRequest(
                    "PATCH",
                    `${apiUrl}/roi-pages/update/${renameRoiPageId}`,
                    {
                        page_name: newPageName
                    }
                );
                // console.log("trd", response);
                if (response.data?.statusCode === 200) {
                    toast.success(response?.data?.msg)
                    getPagesList();
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.responseText);
        }

    }

    const handlePageOrderChange = () => {
        // Extract the roi_page_id from each page object
        const newOrder = pages.map(page => page.roi_page_id);
        // console.log("New Page Order:", newOrder);
        updatePageNumbersInBackend(newOrder);
    };

    const updatePageNumbersInBackend = async (newOrder) => {
        try {
            const response = await performHttpRequest(
                "PATCH",
                `${apiUrl}/roi-pages/updatePageNumbers`,
                {
                    newPageOrder: newOrder
                }
            );
            // console.log("page number response", response);
            if (response?.status === 200) {
                toast.success(response?.data?.message)
            }
        } catch (error) {
            console.error('Error updating page numbers in the backend:', error);
        }
    };

    const handleTemplateSwitch = (e, structure, roi_page_id) => {
        console.log("structure   ----", structure)
        // setEditData(structure);
        e.preventDefault()
        setRoiPageId(roi_page_id)
        setCurrentReportId(roi_page_id)
        try {
            setEditData(null)
            setTimeout(() => {
                setEditData(JSON?.parse(structure));
            }, 0);
        } catch (error) {
            console.error("Error parsing structure:", error);
        }
    };

    const groupedItems = groupBy(roiTemplateDetail, 'roi_template_type_id');

    console.log("configObject",configObject)

    const handleCheckboxChange = async (index) => {
        const updatedPage = { ...reportPages[index] };
        updatedPage.is_active = updatedPage.is_active === 1 ? 0 : 1;
    
        try {
            const response = await performHttpRequest(
                "PATCH",
                `${apiUrl}/roi-pages/update/${updatedPage.roi_page_id}`,
                {
                    is_active: updatedPage.is_active
                }
            );
    
            if (response.data?.statusCode === 200) {
                toast.success(response?.data?.msg);
                // Optionally, update the local state here if you want to reflect the changes without reloading
                const newReportPages = [...reportPages];
                newReportPages[index] = updatedPage;
                setReportPages(newReportPages);
            } else {
                toast.error("Failed to update ROI");
            }
        } catch (error) {
            toast.error(error?.response?.data?.responseText || error.message);
        }
    };

    const onReportSave = async () => {
        
        toast.success('Report Pages updated successfully')

        // Hide the modal by setting its display to none
        if (modalRef.current) {
            modalRef.current.style.display = 'none';
        }
        // Refresh the page after the modal is hidden
        window.location.reload();
        
    };
    

    return (
        <>
            {editorData && (

                <Puck config={configObject} data={editorData} onChange={handleEditChange}>
                    <div className="custom-puck-header">
                        <div className="puck-nav-left">
                            <div className="sidebar-action">
                                <button
                                    className={`sidebar-left ${visibleBars.left ? '' : 'side-hidden'}`}
                                    onClick={() => toggleBar('left')}
                                >
                                    <span className="left-icon"></span>
                                </button>
                                <button
                                    className={id ? `sidebar-right ${visibleBars.right ? '' : 'side-hidden'}` : `sidebar-right ${visibleBars.right ? '' : 'side-hidden'}`}
                                    onClick={() => toggleBar('right')}
                                >
                                    <span className="right-icon"></span>
                                </button>
                            </div>
                            <div className="undo-action">
                                <button className='undo-btn'>
                                    <span className="undo-icon"></span>
                                </button>
                                <button className='redo-btn'>
                                    <span className="redo-icon"></span>
                                </button>
                            </div>
                        </div>
                        <div className="puck-nav-center">
                            <div className="puck-title">
                                <h3 title={roiName}>{roiName}</h3>
                            </div>
                        </div>

                        <div className="puck-nav-right">
                            <button className={`pages btn ${visibleBars.pages ? 'active' : 'side-hidden'}`} onClick={() => toggleBar('pages')}>
                                <span className='pages-icn'></span> Pages</button>
                            <div className="actions">
                                <button className='btn btn-bordered color-cancel' data-bs-toggle="modal" data-bs-target="#shareModal"
                                >Download</button>
                                <button className='btn btn-bordered color-cancel' onClick={() => navigate("")}>Preview</button>
                                <button
                                    className='btn btn-primary add-btn'
                                    onClick={onPublish}
                                >
                                    <span className="publish-icn"></span>
                                    {visibleBars?.pages === false ? "Save" : "Publish"}    </button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex puck-editor-wrapper">
                        <div className={`puck-left-drawer ${visibleBars.left ? '' : 'd-none'}`}>
                            <div className="sidebar-header">
                                <h4>Add a Component</h4>
                            </div>
                            <Drawer>
                                <DrawerROI />
                            </Drawer>
                        </div>
                        <div className="flex-grow-1 puck-preview-outer">
                            <Puck.Preview />
                        </div>
                        <div className={`puck-right-sidebar  ${visibleBars.right ? '' : 'd-none'}`}>
                            <div className="sidebar-header">
                                <h4>Edit Style</h4>
                            </div>
                            <div className="sidebar-wrapper">
                                <Puck.Fields />

                            </div>
                            <div className="sidebar-header">
                                <h4>Outline</h4>
                            </div>
                            <div className="sidebar-wrapper">
                                <Puck.Outline />
                            </div>

                        </div>
                        <div className={`pages-sidebar-list ${visibleBars.pages ? '' : 'd-none'}`}>
                            <div className="pages-list-inner">

                                <div className="heading">
                                    <h5>Pages</h5>
                                </div>
                                <div className="pages-wrap">
                                    <ReactSortable animation={200} delayOnTouchStart={true} delay={2} tag={CustomComponent} list={pages} setList={setPages} onSort={handlePageOrderChange} >
                                        {pages.map((page) => (
                                            /**Add class 'active' with "page-item" for the page which is opened**/

                                            <div className={`page-item-name ${page.roi_page_id === currentReportId ? 'active' : ''}`} data-roi={currentReportId} key={page.roi_page_id}>
                                                <span className='drag-handle' onClick={(e) => e.stopPropagation()}>
                                                    <Svg name="draggable" />
                                                </span>
                                                <div className="page-name" onClick={(e) => handleTemplateSwitch(e, page?.structure, page?.roi_page_id)}>
                                                    {page.page_name}</div>
                                                <div className="dropdown table-dropdown">
                                                    <button className="btn dropdown-tgl" type="button" id="viewoptions" data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <Svg name="action" />
                                                    </button>
                                                    <div className="dropdown-menu" aria-labelledby="viewoptions">

                                                        <span className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#renamepage" onClick={() => handleRenameTemplate(page.roi_page_id, page.page_name)}>
                                                            <div className="icon-circle me-3">
                                                                <Svg name="dropdown-rename" />
                                                            </div>
                                                            <span >Rename</span>
                                                        </span>

                                                        <span className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#duplicatepage" onClick={() => handleDuplicateTemplate(page.roi_page_id, page.page_name, page?.structure)}>
                                                            <div className="icon-circle me-3">
                                                                <Svg name="dropdown-duplicate" />
                                                            </div>
                                                            <span >Duplicate</span>
                                                        </span>

                                                        <span className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#deletepage" onClick={() => handleDeleteTemplate(page.roi_page_id, page.page_name)}>
                                                            <div className="icon-circle me-3">
                                                                <Svg name="dropdown-delete" />
                                                            </div>
                                                            <span >Delete</span>
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>

                                        ))}
                                    </ReactSortable>


                                    <div className="create-page">
                                        <button className='btn add-page' data-bs-toggle="modal" data-bs-target="#addPageModal" onClick={getTemplateDetails}>
                                            <Svg name="add-pg" /> Add Page
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Puck>
            )}


            <div className="modal fade" id="addPageModal" tabIndex={-1} aria-labelledby="addPageModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4>Add Page</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="select-page-type m-0 p-0 border-0">
                                {/* <div className="page-list">
                                    <div className="templ-type">
                                        <h6>Blank page*</h6>
                                    </div>
                                    <div className="row gx-12px">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="temp-wrap ">
                                                <label htmlFor='view0' className="img-wrapper landscape">
                                                    <h4>Landscape</h4>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="temp-wrap ">
                                                <label htmlFor='view0' className="img-wrapper portrait">
                                                    <h4>Portrait</h4>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {Object.keys(groupedItems).map(roiTemplateType => (
                                    <div className="select-page-type" style={{ borderTop: "none" }}>
                                        <div className="page-list">
                                            <div className="heading">
                                                <h5>{groupedItems[roiTemplateType][0].roi_template_name}</h5>
                                                <p>{groupedItems[roiTemplateType][0].roi_template_desc}</p>
                                            </div>
                                            <div className="row gx-12px">
                                                {groupedItems[roiTemplateType].map(item => (
                                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                                        <div className="temp-wrap">
                                                            <input
                                                                id={`view${item?.id}`}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={item?.roi_template_name}
                                                                // checked={landingPage === item?.roi_template_name}
                                                                onChange={(e) => handleLandingPageChange(e, item)}
                                                            />
                                                            <label htmlFor={`view${item?.id}`} className="img-wrapper">
                                                                <img
                                                                    src={item?.roi_template_page_img?.replace(".", "")}
                                                                    alt={item?.roi_template_name}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer button-wrap d-flex justify-content-end">
                            <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                            {/* <button type="button" className="btn btn-primary" onClick={handleTemplateAdd}>Add</button> */}
                            <button type="button" className="btn btn-primary" onClick={(e) => { handleTemplateAdd(); document.getElementById('addPageModal')?.classList?.remove('show'); document.body?.classList?.remove('modal-open'); }} data-bs-dismiss="modal">Add</button>
                        </div>

                    </div>
                </div>
            </div>



            <div className="modal fade" id="shareModal" tabIndex={-1} aria-labelledby="shareModalLabel" aria-hidden="true" ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header align-items-start">
                            <div className="text-wrap">
                                <h4>Download PDF</h4>
                                <p>Select the pages you want to download</p>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="tab-content" id="myTabContent">
                                <div className="select-pages-wrap">
                                    <div className="pages-list">
                                        {reportPages.map((page, index) => (
                                            <div className="form-check" key={index}>
                                                <input className="form-check-input" 
                                                    type="checkbox" 
                                                    id={`page-${index + 1}`}
                                                    value={page.page_name}
                                                    checked={page.is_active === 1} // Check if is_active is 1
                                                    onChange={() => handleCheckboxChange(index)} 
                                                />
                                                <label className="form-check-label" htmlFor={`page-${index + 1}`}>
                                                    {page.page_name}
                                                </label>
                                            </div>
                                        ))}

                                    </div>
                                    <div className="download-button">
                                        <button className='btn btn-black w-100' onClick={onReportSave}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="customvar-modal modal custom-modal fade deleteModal" id="deletepage" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>Delete page</h3>
                                                <p>Are you sure you want to delete <strong>{selectedRoiPageId.page_name}</strong> permanently?</p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-delete ms-3" onClick={confirmDeleteButton} data-bs-dismiss="modal">Confirm delete</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade deleteModal" id="duplicatepage" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>Duplicate page</h3>
                                                <p>Are you sure you want to duplicate <strong>{duplicateTemplate?.page_name}</strong>?</p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-delete ms-3" onClick={confirmDuplicate} data-bs-dismiss="modal">Confirm Duplicate</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="customvar-modal modal custom-modal fade deleteModal" id="renamepage" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card}>

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading mb-3">
                                                <h3>Rename page</h3>
                                            </div>
                                            <div className="form-wrapper mb-3 mb-lg-4">
                                                <label className='form-label-custom'>Enter the new name for the page:</label>
                                                <input type="text" className="form-control" value={newPageName} onChange={(e) => setNewPageName(e.target.value)} />
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-delete ms-3" onClick={confirmRename} data-bs-dismiss="modal">Rename</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}